import State from '../core/State';
import { CreationDetailFragment } from '../generated/graphql';
import initialState from '../initialState';

export const startFetchingCreation = () => (state: State): State => ({
  ...state,
  creation: {
    ...state.creation,
    fetching: state.creation.fetching + 1,
  },
});

export const finishFetchingCreation = (creation: CreationDetailFragment) => (state: State): State => ({
  ...state,
  creation: {
    ...state.creation,
    creation,
    fetching: state.creation.fetching - 1,
  },
});

export const setCreation = (creation: CreationDetailFragment) => (state: State): State => ({
  ...state,
  creation: {
    ...state.creation,
    creation,
  },
});

export const disposeCreation = () => (state: State): State => ({
  ...state,
  creation: {
    ...state.creation,
    creation: initialState.creation.creation,
  },
});
